export type DeputyPersonRequestBody = {
  isPrimary: boolean;
  firstName: string | null;
  lastName: string | null;
  dateOfBirth: string | null;
  identificationNumber: string | null;
  personalIdType: DeputyPersonRequestBody.personalIdType | null;
  personalIdNumber: string | null;
  validUntil: string | null;
  issuedBy: string | null;
};

export namespace DeputyPersonRequestBody {
  export enum personalIdType {
    ID_TYPE_ID = 'ID_TYPE_ID',
    ID_TYPE_PASSPORT = 'ID_TYPE_PASSPORT',
    ID_TYPE_DRIVING_LICENSE = 'ID_TYPE_DRIVING_LICENSE',
    ID_TYPE_OTHER = 'ID_TYPE_OTHER',
  }
}
